<div class="modal-header">
  <h3 class="modal-title">Suggested Collaborators</h3>
  <button
    type="button"
    (click)="dismiss()"
    class="btn-close"
    title="Close"></button>
</div>

<div class="modal-content">
  <ng-container *ngIf="suggestions.length === 0">
    <div class="no-suggestions">
      <img alt src="assets/images/logo-no-type.svg" />
      <p>No suggested collaborators could be found.</p>
    </div>
  </ng-container>
  <ng-container *ngFor="let suggestion of suggestions">
    <div class="suggestion" *ngIf="suggestion && suggestion.participant">
      <div class="top">
        <div class="content">
          <profile-picture
            [user]="suggestion.participant.user"></profile-picture>
          <name-tag [user]="suggestion.participant.user"></name-tag>
          <p *ngIf="suggestion.ideas.length > 0">
            Suggested because of their work on these ideas:
          </p>
        </div>
        <div class="action">
          <button
            class="btn btn-primary"
            *ngIf="!suggestion.added"
            (click)="add(suggestion)">
            Add as Collabroator
          </button>
          <button class="btn" disabled *ngIf="suggestion.added">
            Added as Collaborator
          </button>
        </div>
      </div>

      <div class="ideas" *ngIf="suggestion.ideas.length > 0">
        <app-idea-card
          *ngFor="let idea of suggestion.ideas"
          [idea]="idea"
          [session]="session"
          [small]="true"
          [nopreview]="true"
          (click)="openIdeaModal(idea)"></app-idea-card>
      </div>
    </div>
  </ng-container>
</div>
